import { createApp               } from 'vue'
import   router                    from './router';
import { createPinia             } from 'pinia'
import   piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import   checkPermision            from '@/core/directiveCoreCheckPermission'; 
import { AxiosInterceptor        } from '@/core/axiosCoreInterceptor'

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";



const options = {
    position: "top-right",
    timeout: 7000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
};

import '../node_modules/admin-lte/plugins/fontawesome-free/css/all.min.css'
import '../node_modules/admin-lte/plugins/overlayScrollbars/css/OverlayScrollbars.min.css'
import '../node_modules/admin-lte/dist/css/adminlte.min.css'
import '@/assets/css/site.css'



import '../node_modules/admin-lte/plugins/jquery/jquery.min.js'
import '../node_modules/admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js'
import '../node_modules/admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js'
import '../node_modules/admin-lte/dist/js/adminlte.js'
import App from './App.vue'

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

AxiosInterceptor();

const myApp = createApp(App);

myApp.use(Toast, options);
myApp.directive('checkPermision', checkPermision);
myApp.use(router);
myApp.use(pinia);
myApp.mount('#app')
